import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../css/AddCompetition.css';
import axios from 'axios';

const AddCompetitionForm = ({ onClose, oncompetitionAdded }) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    name: '',
    venue: '',
    start_date: null,
    end_date: null,
    status: true,
    location: '',
    code: '',
    logo: null,
    odf_general: null,
    odf_sport: null,
    odf_codes: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'status') {
      setFormData((prev) => ({ ...prev, [name]: value === 'Active' }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDateChange = (name, date) => {
    setFormData((prev) => ({ ...prev, [name]: date }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFormData((prev) => ({
      ...prev,
      logo: file,
      logoPreview: URL.createObjectURL(file),
      logoName: file.name,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();

    data.append('name', formData.name);
    data.append('start_date', formData.start_date?.toISOString());
    data.append('end_date', formData.end_date?.toISOString());
    data.append('status', formData.status);
    data.append('location', formData.location);
    data.append('code', formData.code);
    if (formData.logo) data.append('logo', formData.logo);

    try {
      await axios.post(`${API_URL}/ems/competitions`, data);
      oncompetitionAdded();
      onClose();
    } catch (err) {
      console.error('Error creating competition:', err.response?.data || err.message);
      alert('Failed to create competition.');
    }
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
    >
      <div className="modal-dialog modal-md" role="document">
        <div className="modal-content">
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="modal-header">
              <h5 className="modal-title">Add Competition</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              />
            </div>

            <div className="add-competition modal-body">
              {/* Competition Name */}
              <div className="mb-3">
                <label className="add-competition form-label">Competition Name</label>
                <input
                  type="text"
                  name="name"
                  className="add-competition form-control text-dark"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{ border: '1px solid #000' }}
                />
              </div>

              {/* Start & End Dates */}
              <div className="row g-2 mb-3">
                <div className="col-6">
                  <label className="add-competition form-label">Start Date</label>
                  <DatePicker
                    selected={formData.start_date}
                    onChange={(date) => handleDateChange('start_date', date)}
                    className="add-competition form-control text-dark"
                    wrapperClassName="w-100"
                    dateFormat="dd-MMM-yyyy"
                    placeholderText="Select start date"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    onChangeRaw={(e) => e.preventDefault()}
                  />
                </div>
                <div className="col-6">
                  <label className="add-competition form-label">End Date</label>
                  <DatePicker
                    selected={formData.end_date}
                    onChange={(date) => handleDateChange('end_date', date)}
                    className="add-competition form-control text-dark"
                    wrapperClassName="w-100"
                    dateFormat="dd-MMM-yyyy"
                    placeholderText="Select end date"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    onChangeRaw={(e) => e.preventDefault()}
                  />
                </div>
              </div>

              {/* Location */}
              <div className="mb-3">
                <label className="add-competition form-label">Location</label>
                <input
                  type="text"
                  name="location"
                  className="add-competition form-control text-dark"
                  value={formData.location}
                  onChange={handleChange}
                />
              </div>

              {/* Code */}
              <div className="mb-3">
                <label className="add-competition form-label">Code</label>
                <input
                  type="text"
                  name="code"
                  className="add-competition form-control text-dark"
                  value={formData.code}
                  onChange={handleChange}
                />
              </div>

              {/* Logo */}
              <div className="mb-3">
                <label className="add-competition form-label">Upload Logo</label>
                <input
                  type="file"
                  name="logo"
                  accept="image/*"
                  className="add-competition form-control"
                  onChange={handleFileChange}
                />
              </div>

              {/* Status */}
              <div className="mb-4">
                <label className="add-competition form-label d-block">Status</label>
                <div className="status-toggle">
                  <label htmlFor="addStatusActive">
                    <input
                      type="radio"
                      name="status"
                      id="addStatusActive"
                      value="Active"
                      checked={formData.status === true}
                      onChange={handleChange}
                    />
                    Active
                  </label>
                  <label htmlFor="addStatusInactive">
                    <input
                      type="radio"
                      name="status"
                      id="addStatusInactive"
                      value="Inactive"
                      checked={formData.status === false}
                      onChange={handleChange}
                    />
                    Inactive
                  </label>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="submit"
                className="btn"
                style={{ backgroundColor: '#d9a128ba', color: '#fff', border: 'none', fontWeight: 'bold' }}
              >
                Add
              </button>
              <button
                type="button"
                className="btn"
                onClick={onClose}
                style={{ backgroundColor: '#000', color: 'white', border: 'none', fontWeight: 'bold' }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCompetitionForm;
